<div class="row">
  <div class="col">
    <div class="mb-3">
      <label class="form-label" for="maritalStatus">
        Employment Status
        <span *ngIf="controlIsRequired('EmploymentStatus')" class="color-error"
          >*</span
        >
      </label>
      <select
        id="maritalStatus"
        class="form-select"
        aria-label="Marital status dropdown menu."
        [formControl]="getFormControl('EmploymentStatus')"
        (change)="onChange($event)"
      >
        <option selected value="">Select employment status.</option>
        <option *ngFor="let item of employmentStatus" [value]="item.Value">
          {{ item.Text }}
        </option>
      </select>
    </div>
  </div>
</div>
